import { Hero } from "@/components/landing/Hero";

export default function Landing() {
  return (
    <div data-testid="landing-page">
      <Hero />
    </div>
  );
}
